<template>
  <div class="cart" v-if="$store.getters['auth/isRole']('ROLE_AGENT') == true">
    <div class="cart__header">
      <div class="cart__header-container">
        <span class="cart__header-text">Qui est le destinataire du colis ?</span>
        <a href="" :class="'cart__header-btn active--' + showTechSelector"
          @click.prevent="showTechSelector = !showTechSelector"><img src="/static/img/pictos/flecheblanche.svg"
            class=""></a>
        <select class="tech-selector" name="" v-if="showTechSelector == 1" @change="changeTech()">
          <option :value="me.id">{{ me.firstname }} (mon agence)</option>
          <option :value="tech.technician.id" v-for="tech in myTechs" :key="tech.technician.id">{{
                      tech.technician.lastname }} - {{ tech.technician.firstname }}</option>
        </select>
      </div>
    </div>
    <div class="cart__loader" v-if="$store.getters['loaderCartState'] == true">
      <LoaderCart></LoaderCart>
    </div>
    <div class="cart__products" v-else-if="cart.lines">
      <ProductCart v-for="item in cart.lines" :item="item" :key="item.product.id" :forUser="cart.created_for_user">
      </ProductCart>
    </div>
    <div class="cart__empty" v-else>
      <span>Votre panier est vide</span>
    </div>
    <div class="cart__btns">
      <textarea v-model="comment" class="comment" placeholder="Message à l’attention du magasinier"></textarea>
      <CartValid :comment="comment" @success="validCartSuccess"></CartValid>
      <div href="" class="cart__info info">
        <span class="info__total">Total :</span>
        <span class="info__price"><strong>{{ total }}</strong></span>
        <span class="info__quantity-text">€</span>
      </div>
    </div>
  </div>
  <div class="cart cart--mobile" v-else-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true">
    <div class="cart__products" v-if="cart.lines">
      <ProductCart v-for="item in cart.lines" :item="item" :key="item.product.id"></ProductCart>
    </div>
  </div>
</template>

<script>
import { languages_trad } from "@/traductions/config";
import { defaultLocale } from "@/traductions/config";

import ProductCart from "@/components/Product/ProductCart";
import CartValid from "@/components/Cart/CartValid";
import LoaderCart from "@/components/Global/LoaderCart";

export default {
  name: "Cart",
  data() {
    return {
      locale: this.$i18n.locale,
      languages: languages_trad,
      showTechSelector: 0,
      comment: null
    };
  },
  computed: {
    // Récupération de mon panier
    cart: function() {
      let cart = this.$store.getters["order/getMyCart"];
      return cart;
    },
    // Récupération du nombre de produits du panier
    total: function() {
      let  total = 0;
      if(this.cart.lines && this.cart.lines.length > 0){
        for(let i = 0; i < this.cart.lines.length; i++){
          let price = 0;
          for(let y=0; y<this.cart.lines[i].product.prices.length; y++){
            if(this.cart.lines[i].product.prices[y].entreprise_description == 'MCI'){
              price = this.cart.lines[i].product.prices[y].price;
            }
          }

          total += this.cart.lines[i].quantity * price;
        }
      }
      return total.toFixed(2);
    },
    // Récupération de mes infos personnelles
    me: function() {
      let me = this.$store.getters["auth/user"];

      // Cas ou le retour était en LocalStorage et sous la forme d'un json "stringifié" : on le retransforme en objet JS.
      if(typeof(me) == 'string'){
        return JSON.parse(me)
      }else{
        return me;
      }
    },
    // Récupération de mes techniciens si je suis coordinateur
    myTechs: function() {
      let myTechs = this.$store.getters["auth/myTechs"];

      // Cas ou le retour était en LocalStorage et sous la forme d'un json "stringifié" : on le retransforme en objet JS.
      if(typeof(myTechs) == 'string'){
        return JSON.parse(myTechs)
      }else{
        return myTechs;
      }
    },
  },
  created() {
  },
  mounted() {
    // Permet de relancer une requête au back pour récupérer le panier à jour
    this.$store.dispatch("order/getMyCart").then(function(){ });
  },
  watch: {
    locale(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("defaultLocale", lang);
    }
  },
  methods: {
    // Changement du destinataire du panier
    changeTech(){
      self = this;

      // Récupération du panier stocké côté Vue
      let cart = this.$store.getters["order/getMyCart"];

      // Confirmation JS
      if (window.confirm("Confirmez-vous le changement de destinataire de la commande ?")) {

        // Affichage du loader du panier le temps que la requête AJAX se fasse
        this.$store.dispatch('showCartLoader');

        // Envoi de la requête Ajax qui met à jour le destinataire de la commande = champ created_for_user
        this.$http.patch('order/cart/setforuser/'+cart.id, {created_for_user_id : event.target.value}).then(response => {

          // On récupère le panier avec les données à jour
          this.$store.dispatch("order/getMyCart").then(function(){

            // Une fois le panier récupéré on cache le loader
            self.$store.dispatch('hideCartLoader');

            // Message de succès
            self.$toastr.success(self.$i18n.t("success.cart.receiver-updated"));
          });
        }).catch(error => {

          // Erreur au niveau de la requête : on recache le loader
          this.$store.dispatch('hideCartLoader');
        })
      }
    },
    validCartSuccess() {
      this.comment = null
    }
  },
  components: {
    ProductCart,
    CartValid,
    LoaderCart
  }
};
</script>


<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: white;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $grisclair;
  border-radius: 20px;
  height: 5px;
}

.cart {
  padding-bottom: 79px;

  .tech-selector {
    width: 100%;
    background: $color3;
    border: 1px solid $color2;
    color: white;
    padding: 10px 20px;
    font-size: 12px;
    outline: none;
  }

  &__products {
    overflow: auto;
    height: calc(100vh - 375px);
    margin-bottom: 80px;
  }

  &__loader {
    overflow: auto;
    height: calc(100vh - 375px);
    margin-bottom: 80px;
    position: relative;
  }

  &__empty {
    overflow: auto;
    height: calc(100vh - 375px);
    margin-bottom: 80px;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      font-family: 'ClanFFBlack';
      color: $grisclair;
      font-size: 22px;
    }
  }

  &__header {
    height: 80px;
    background-color: $color3;
    position: relative;

    .cart__header-btn {
      width: 80px;
      text-align: center;
      height: 40px;
      color: white;
      line-height: 36px;
      background-color: $color2;

      img {
        width: 16px;
        transition: transform 100ms ease-in;
      }

      &.active--true {
        img {
          transform: rotate(90deg);
        }
      }
    }

    .cart__header-text {
      font-family: 'ClanProBold';
      color: white;
      flex: 1;
      font-size: 12px;
      text-align: center;
      line-height: 40px;
    }
  }

  &__header-container {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: flex-end;
    height: 100%;
  }

  &__product {
    width: 100%;
    height: auto;
    border-bottom: 1px solid $grisclair;
  }

  &__btns {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    position: fixed;
    bottom: 0;
    right: 0;
    width: 25%; //box-shadow: 5px 0 6px $grisclair;

    .btn {
      background-color: $vert;
      outline: none;
      border-radius: 0;
      padding: 0 10px;
      height: 80px;
      line-height: 80px;
      width: 50%;

      &__picto {
        width: 30px;
      }

      &__text {
        color: white;
        font-family: 'ClanProBold';
        font-size: 11px;
      }
    }

    .info {
      width: 50%;
      background-color: white;
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      align-items: center;
      text-align: center;
      justify-content: center;

      &__total {
        font-family: 'ClanProBold';
        color: $color1;
        text-transform: uppercase;
        font-size: 12px;
      }

      &__quantity {
        height: 55px;
        width: 55px;
        border-radius: 50%;
        border: 1px solid $grisclair;
        text-align: center;
        line-height: 50px;
        margin: 0 10px;
      }

      &__price {
        height: 55px;
        width: 55px;
        text-align: center;
        line-height: 50px;
        margin: 0 10px;
      }

      &__quantity-text {
        color: $grisfonce;
        font-family: 'ClanPro';
        font-size: 12px;
      }
    }
  }

  .product {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    position: relative;
    padding-top: 15px;
    background-color: white;

    &__image-container {
      width: 100px;
      height: 100%;
    }

    &__image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &__info-container {
      flex: 1;
      height: 100%;
      padding: 0 10px;
    }

    &__info-main {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      width: 100%;
      align-items: top;

      .product__name-container {
        flex: 1;
        line-height: 1;
      }

      .product__price-container {
        width: 110px;
        text-align: left;
        line-height: 1;
        padding-left: 20px;
      }
    }

    .quantity {
      flex: 1;

      &__text {
        color: $grisfonce;
        font-family: 'ClanPro';
        text-transform: uppercase;
        font-size: 12px;
        margin-left: 20px;
      }

      &__value {
        width: 55px;
        height: 55px;
        border-radius: 50%;
        background-color: $grisclair;
        line-height: 55px;
        text-align: center;
        border: none;
        margin-bottom: 15px;
        outline: none;
        margin-left: 5%;
        font-family: 'ClanFFBlack';
        font-weight: normal;
        color: $color1;
      }
    }

    .imputation,
    .tech {
      &__text {
        font-size: 12px;
        color: $grisfonce;
        font-family: 'ClanPro';
        width: 105px;
        display: inline-block;
        text-align: right;
      }

      &__selector {
        font-size: 12px;
        color: $grisfonce;
        font-family: 'ClanPro';
        padding: 5px 10px;
        border: 1px solid $color1;
        margin-left: 5px;
        width: 105px;
      }
    }

    .technicien {
      margin-top: 10px;
    }

    &__name {
      font-size: 15px;
      text-transform: uppercase;
      font-family: 'ClanFFBlack';
      color: $color1;
    }

    &__price {
      font-size: 25px;
      color: $color2;
      white-space: nowrap;

      strong {
        font-family: 'ClanFFBlack';
        font-weight: normal;
      }

      sup {
        font-size: 10px;
        font-family: 'ClanPro';
      }
    }

    &__price-text {
      font-size: 10px;
      font-family: 'ClanPro';
      color: $color2;
    }

    &__code {
      font-size: 12px;
      color: $grisfonce;
      font-family: 'ClanPro';
    }

    &__btns {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      align-items: flex-end;
      margin-top: 20px;
      width: 100%;

    }

    &__btn {
      width: 80px;
      text-align: center;
      height: 40px;
      color: white;
      line-height: 36px;

      &--see {
        background-color: $color2;
      }

      &--add {
        background-color: $color3;
      }

      img {
        width: 16px;
      }

      &--delete {
        background-color: $color1;

        img {
          width: 12px;
        }
      }
    }
  }

  &--mobile {
    .cart__products {
      padding: 20px;
      height: auto;
      margin-bottom: 0;

      .product {
        padding-top: 0;
      }
    }
  }

  .comment {
    width: 100%;
    height: 80px;
    border: solid $grisclair;
    border-width: 1px 0 1px 1px;
    padding: 10px;
    font-size: 12px;
  }
}

@media screen and (max-width: 1680px) {
  .cart__btns {
    width: 415px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Cart/Cart.vue